/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment';

// initial state
const state = {
  messages: [],
  session: {},
  inputMessage: {},
  inputHeight: 47,
  chipsHeight: 64,
  isSending: false,
};

// getters
const getters = {
  tmpMessage: state => {
    if (state.session) {
      return state.inputMessage[state.session.id];
    }
    return '';
  },
  findWhereMessage: state => params => {
    let beforeIndex = state.messages.length;
    let afterIndex = 0;
    if (params.beforeId) {
      beforeIndex = _.findLastIndex(state.messages, m => m.id === params.beforeId);
      if (beforeIndex < 0) {
        beforeIndex = state.messages.length;
      }
    }
    if (params.afterId) {
      afterIndex = state.messages.findIndex(m => m.id === params.afterId);
      if (afterIndex < 0) {
        afterIndex = 0;
      }
    }
    return _.find(state.messages.slice(afterIndex, beforeIndex).reverse(), params.where);
  },
  activeAsk: state => {
    const lastActiveIndex = _.findLastIndex(state.messages, msg => msg.status === 'active');
    if (lastActiveIndex >= 0) {
      return state.messages[lastActiveIndex];
    }
    return false;
  },
  isSendBtnDisabled: (state, gt) => {
    if (gt.activeAsk) {
      if (!!gt.activeAsk.params && gt.activeAsk.params.type === 'choice') {
        return !gt.activeAsk.params.isCustomInput;
      }
      return false;
    }
    return true;
  },
};

// actions
const actions = {
  async sendMessage({ state, dispatch, commit }, { message, allowDirectInput = false }) {
    commit('setSendingStatus', true);
    // const prevInputMessage = state.inputMessage && state.inputMessage.message ? state.inputMessage.message : '';
    dispatch('inputMessage', '');
    window.$socket.emit(
      '/answer/Session',
      {
        id: state.session.id,
        message,
        allowDirectInput,
      },
      () => {
        // TODO: create new event for errors
        // if (data.error) {
        // 	dispatch(ADD_TOAST_MESSAGE, { type: 'error', text: data.error }, { root: true });
        // 	console.log(data.error);
        // 	dispatch('inputMessage', prevInputMessage);
        // 	commit('setSendingStatus', false);
        // } else {
        // 	commit('setSendingStatus', false);
        // }
        commit('setSendingStatus', false);
      }
    );
  },
  async teachSession({ state, dispatch, commit, rootGetters }, message) {
    const tutorCommand = rootGetters['configs/tutorCommand'];
    if (!tutorCommand || !tutorCommand.command) return;
    commit('setSendingStatus', true);
    // const prevInputMessage = state.inputMessage && state.inputMessage.message ? state.inputMessage.message : '';
    dispatch('inputMessage', '');
    window.$socket.emit(
      '/answer/Session',
      {
        id: state.session.id,
        message: tutorCommand.command,
      },
      () => {
        // TODO: create new event for errors
        // if (data.error) {
        // 	dispatch(ADD_TOAST_MESSAGE, { type: 'error', text: data.error }, { root: true });
        // 	console.log(data.error);
        // 	dispatch('inputMessage', prevInputMessage);
        // 	commit('setSendingStatus', false);
        // } else {
        // 	commit('setSendingStatus', false);
        // }
        commit('setSendingStatus', false);
      }
    );
  },
  setMessages({ commit }, data) {
    commit('setMessages', data.sessionUIs);
    commit('setSession', data);
  },
  receiveMessage({ commit }, message) {
    commit('addMessage', message);
  },
  editMessage({ commit }, message) {
    commit('editMessage', message);
  },
  inputMessage({ commit, state }, message) {
    commit('inputMessage', { id: state.session.id, message });
  },
  setInputHeight({ commit }, height) {
    commit('setInputHeight', height);
  },
  setChipsHeight({ commit }, height) {
    commit('setChipsHeight', height);
  },
  closeSession() {
    window.$socket.emit('/close/Session', { id: state.session.id });
  },
  cleanMessages({ commit }) {
    commit('setMessages', []);
  },
};

// mutations
const mutations = {
  setSendingStatus(state, isSending) {
    state.isSending = isSending;
  },
  setInputHeight(state, height) {
    state.inputHeight = height;
  },
  setChipsHeight(state, height) {
    state.chipsHeight = height;
  },
  setMessages(state, messages) {
    state.messages = _.sortBy(
      messages.map(msg => {
        const m = msg;

        if (m.params && m.params.type === 'choice' && !_.isObject(m.params.list[0])) {
          m.params.list = m.params.list.map(item => ({
            title: item,
            value: item,
          }));
        }

        return {
          ...m,
          pureCreatedAt: moment(m.createdAt),
          createdAt: moment(m.createdAt).format('DD MMMM YYYY  HH:mm'),
        };
      }),
      m => moment(m.pureCreatedAt)
    );
  },
  addDebugMessage(state, message) {
    if (!message) return;

    const lastMessage = state.messages?.[state.messages?.length - 1];
    if (lastMessage?.debug && lastMessage.params?.prompt === message) {
      lastMessage.params.count += 1;
    } else {
      const now = new Date();
      const msg = {
        id: +now,
        debug: true,
        className: 'UIFormRequest',
        params: {
          enqueueAgent: true,
          force: true,
          prompt: message,
          rawPrompt: message,
          count: 1,
        },
        pureCreatedAt: moment(now),
        createdAt: moment(now).format('DD MMMM YYYY  HH:mm'),
        updatedAt: now.toUTCString(),
      };
      state.messages = _.sortBy([...state.messages, msg], m => moment(m.pureCreatedAt));
    }
  },
  addMessage(state, message) {
    const msg = { ...message };
    if (msg.sessionId !== state.session.id) return;
    if (msg.params && msg.params.type === 'choice' && !_.isObject(msg.params.list[0])) {
      msg.params.list = msg.params.list.map(item => ({
        title: item,
        value: item,
      }));
    }
    msg.pureCreatedAt = moment(msg.createdAt);
    msg.createdAt = moment(msg.createdAt).format('DD MMMM YYYY  HH:mm');
    state.messages = _.sortBy([...state.messages, msg], m => moment(m.pureCreatedAt));
  },
  editMessage(state, message) {
    const messageIndex = _.findIndex(state.messages, { id: message.id });
    if (messageIndex >= 0) {
      const msg = { ...message };
      if (msg.params && msg.params.type === 'choice' && !_.isObject(msg.params.list[0])) {
        msg.params.list = msg.params.list.map(item => ({
          title: item,
          value: item,
        }));
      }
      msg.pureCreatedAt = moment(msg.createdAt);
      msg.createdAt = moment(msg.createdAt).format('DD MMMM YYYY  HH:mm');
      state.messages.splice(messageIndex, 1, msg);
    }
  },
  setSession(state, session) {
    state.session = {
      ...session,
      headline: session.title || Vue.i18n.translate('Session'),
      date: moment(session.createdAt).format('DD MMMM YYYY  HH:mm'),
    };
  },
  inputMessage(state, data) {
    Vue.set(state.inputMessage, data.id, data.message);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
